import Vue from 'vue'
import Vuex from 'vuex'
import conductor from '@/api/conductor'
import router from '@/router'
import assert from 'assert'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

// TODO Find a better way to defined storage keys
const storagePrefix = 'conductor-ui-'
const storageConductorApis = storagePrefix + 'conductor-apis'
const storageIsLightTheme = storagePrefix + 'is-light-theme'
const storageEditorRenderer = storagePrefix + 'editor-renderer'

export default new Vuex.Store({
  state: {
    readOnly: true,
    isLightTheme: false,
    editorRenderer: 'ace',
    conductorUrl: null,
    conductorConfig: {},
    themeColor: '#000000',
    conductorApiId: null,
    conductorApis: [
      {
        url: 'http://localhost:8080/api',
        id: 'local',
        readOnly: true,
        color: '#808080'
      }
    ],
    messageHistory: [],
    messageHistoryLimit: 2,
    workflowDefinitions: [],
    workflowDefinition: {},
    taskDefinitions: [],
    taskDefinition: {},
    workflows: [],
    workflow: {},
    workflowFilter: {
      freeText: '*',
      start: 0,
      size: 50,
      sort: 'startTime:DESC'
    },
    workflowFilterCount: 0,
    tasks: [],
    taskFilter: {
      freeText: '*',
      start: 0,
      size: 50,
      sort: 'startTime:DESC'
    },
    task: {},
    taskFilterCount: 0,
    taskQueues: [],
    eventHandlers: [],
    eventHandler: {}
  },
  getters: {
    taskDefinitionsOrderByCreateTimeDesc: state => {
      return state.taskDefinitions
        .filter(() => true)
        .sort((a, b) => b.createTime - a.createTime)
    },
    workflowDefinitionsOrderByUpdateTimeDesc: state => {
      return state.workflowDefinitions
        .filter(() => true)
        .sort((a, b) => b.updateTime - a.updateTime)
    },
    taskQueuesByLastPollTime: state => {
      return state.taskQueues
        .filter(() => true)
        .sort((a, b) => b.lastPollTime - a.lastPollTime)
    },
    workflowTasksDefined: state => {
      if (state.workflow.workflowDefinition !== undefined)
        return state.workflow.workflowDefinition.tasks
      return []
    },
    workflowTasksOrderBySeq: state => {
      if (state.workflow.tasks !== undefined)
        return state.workflow.tasks
          .filter(() => true)
          .sort((a, b) => b.seq - a.seq)
      return []
    },
    eventHandlersOrderByNameAsc: state => {
      return state.eventHandlers
        .filter(() => true)
        .sort((a, b) => b.name > a.name)
    }
  },
  mutations: {
    loadConductorApis(state) {
      var conductorApis = localStorage.getItem(storageConductorApis)
      if (conductorApis != null) {
        try {
          state.conductorApis = JSON.parse(conductorApis)
        } catch (error) {
          state.messageHistory.push({
            timestamp: Date.now(),
            content:
              'Failed to Load ConductorApis from localStorage. Remove ' +
              storageConductorApis +
              ' from localStorage or save a new definition.',
            error: error
          })
        }
      }
    },
    loadThemes(state) {
      var isLightTheme = localStorage.getItem(storageIsLightTheme)
      if (isLightTheme != null) {
        try {
          isLightTheme = JSON.parse(isLightTheme)
          if (typeof isLightTheme === 'boolean') {
            state.isLightTheme = isLightTheme
          } else {
            localStorage.removeItem(storageIsLightTheme)
            state.messageHistory.push({
              timestamp: Date.now(),
              content:
                'Failed to Load Themes from localStorage. Reverted to default.'
            })
          }
        } catch (error) {
          localStorage.removeItem(storageIsLightTheme)
          state.messageHistory.push({
            timestamp: Date.now(),
            content:
              'Failed to Load Themes from localStorage. Reverted to default.'
          })
        }
      }
    },
    loadEditorRenderers(state) {
      var editorRenderer = localStorage.getItem(storageEditorRenderer)
      if (editorRenderer != null) {
        try {
          editorRenderer = JSON.parse(editorRenderer)
          if (editorRenderer === 'ace' || editorRenderer === 'dummy') {
            state.editorRenderer = editorRenderer
          } else {
            localStorage.removeItem(storageEditorRenderer)
            state.messageHistory.push({
              timestamp: Date.now(),
              content:
                'Failed to Load Editor Renderers from localStorage. Reverted to default.'
            })
          }
        } catch (error) {
          localStorage.removeItem(storageEditorRenderer)
          state.messageHistory.push({
            timestamp: Date.now(),
            content:
              'Failed to Load Editor Renderers from localStorage. Reverted to default.'
          })
        }
      }
    },
    saveConductorApis(state) {
      localStorage.setItem(
        storageConductorApis,
        JSON.stringify(state.conductorApis)
      )
    },
    setConductorApiId(state, conductorApiId) {
      state.conductorApiId = conductorApiId
      var conductorApi = state.conductorApis.find(el => el.id == conductorApiId)
      if (conductorApi != undefined) {
        state.conductorUrl = conductorApi.url
        state.themeColor = conductorApi.color
        state.readOnly = conductorApi.readOnly
      } else {
        // 404
      }
    },
    setConductorApis(state, conductorApis) {
      state.conductorApis = conductorApis
    },
    setConductorUrl(state, conductorUrl) {
      state.conductorUrl = conductorUrl
    },
    setConductorConfig(state, conductorConfig) {
      state.conductorConfig = conductorConfig
    },
    setWorkflowDefinitions(state, workflowDefinitions) {
      state.workflowDefinitions = workflowDefinitions
    },
    setWorkflowDefinition(state, workflowDefinition) {
      state.workflowDefinition = workflowDefinition
    },
    setTaskDefinition(state, taskDefinition) {
      state.taskDefinition = taskDefinition
    },
    setTaskDefinitions(state, taskDefinitions) {
      state.taskDefinitions = taskDefinitions
    },
    setWorkflow(state, workflow) {
      state.workflow = workflow
    },
    setWorkflows(state, workflows) {
      state.workflows = workflows
    },
    setWorkflowFilter(state, workflowFilter) {
      state.workflowFilter = workflowFilter
    },
    setWorkflowFilterCount(state, workflowFilterCount) {
      state.workflowFilterCount = workflowFilterCount
    },
    setTasks(state, tasks) {
      state.tasks = tasks
    },
    setTask(state, task) {
      state.task = task
    },
    setTaskFilter(state, taskFilter) {
      state.taskFilter = taskFilter
    },
    setTaskFilterCount(state, taskFilterCount) {
      state.taskFilterCount = taskFilterCount
    },
    setTaskQueues(state, taskQueues) {
      state.taskQueues = taskQueues
    },
    buildTaskQueues(state, [taskQueueSize, taskQueuePollData]) {
      var taskQueues = {}
      var key = null
      // TaskQueueSize
      for (key in taskQueueSize) {
        var domain = ''
        var queueName = key
        if (key.indexOf(':') == !-1) {
          queueName = key.split(':')[1]
          domain = key.split(':')[0]
        }

        taskQueues[key] = {
          id: key,
          queueName: queueName,
          domain: domain,
          ...taskQueueSize[key]['c']
        }
      }
      // TaskQueuePollData
      for (var i in taskQueuePollData) {
        key = taskQueuePollData[i]['queueName']
        if (taskQueuePollData[i]['domain']) {
          key = taskQueuePollData[i]['domain'] + ':' + key
        }
        if (key in taskQueues) {
          taskQueues[key] = { ...taskQueues[key], ...taskQueuePollData[i] }
        } else {
          taskQueues[key] = taskQueuePollData[i]
        }
      }
      state.taskQueues = Object.values(taskQueues)
    },
    setEventHandlers(state, eventHandlers) {
      state.eventHandlers = eventHandlers
    },
    setEventHandler(state, eventHandler) {
      state.eventHandler = eventHandler
    },
    handleError(state, error) {
      if (state.messageHistory.length >= state.messageHistoryLimit) {
        state.messageHistory.shift()
      }
      var content = ''
      if (error.response) {
        content = error.response.data
      } else if (error.request) {
        content = error.request.data
      } else {
        content = error
      }
      state.messageHistory.push({
        timestamp: Date.now(),
        content: content,
        error: error
      })
    },
    cleanMessageHistory(state) {
      state.messageHistory = []
    },
    toggleTheme(state) {
      state.isLightTheme = !state.isLightTheme
      localStorage.setItem(
        storageIsLightTheme,
        JSON.stringify(state.isLightTheme)
      )
    },
    setEditorRenderer(state, editorRenderer) {
      if (editorRenderer === 'ace' || editorRenderer === 'dummy') {
        state.editorRenderer = editorRenderer
        localStorage.setItem(
          storageEditorRenderer,
          JSON.stringify(state.editorRenderer)
        )
      } else {
        // TODO Add error to history message
      }
    }
  },
  actions: {
    switchConductorApi(context, conductorApiId) {
      router.push({
        name: 'workflowList',
        params: { conductorApiId: conductorApiId }
      })
    },
    // Config
    getConductorConfig({ commit, state }) {
      commit('setConductorConfig', {})
      conductor
        .adminConfig(state.conductorUrl)
        .then(response => {
          commit('setConductorConfig', response.data)
        })
        .catch(e => commit('handleError', e))
    },
    // Task Definitions
    getTaskDefinitions({ commit, state }) {
      commit('setTaskDefinitions', [])
      conductor
        .getTaskDefinitions(state.conductorUrl)
        .then(response => {
          commit('setTaskDefinitions', response.data)
        })
        .catch(e => commit('handleError', e))
    },
    getTaskDefinition({ commit, state }, taskType) {
      commit('setTaskDefinition', {})
      conductor
        .getTaskDefinition(state.conductorUrl, taskType)
        .then(response => {
          commit('setTaskDefinition', response.data)
        })
        .catch(e => commit('handleError', e))
    },
    createTaskDefinition({ commit, state }, taskDefinition) {
      assert(!state.readOnly)
      conductor
        .createTaskDefinition(state.conductorUrl, taskDefinition)
        .then(() => {
          router.push({
            name: 'taskDefinition',
            params: { taskType: taskDefinition.name }
          })
        })
        .catch(e => commit('handleError', e))
    },
    updateTaskDefinition({ commit, state }, taskDefinition) {
      assert(!state.readOnly)
      conductor
        .updateTaskDefinition(state.conductorUrl, taskDefinition)
        .then(() => {
          router.push({
            name: 'taskDefinition',
            params: { taskType: taskDefinition.name }
          })
        })
        .catch(e => commit('handleError', e))
    },
    cancelUpdateTaskDefinition({ commit }, taskType) {
      commit('setTaskDefinition', {})
      router.push({ name: 'taskDefinition', params: { taskType: taskType } })
    },
    // Workflow Definitions
    getWorkflowDefinitions({ commit, state }) {
      commit('setWorkflowDefinitions', [])
      conductor
        .getWorkflowDefinitions(state.conductorUrl)
        .then(response => {
          commit('setWorkflowDefinitions', response.data)
        })
        .catch(e => commit('handleError', e))
    },
    getWorkflowDefinition(
      { commit, state },
      [workflowDefinitionName, workflowDefinitionVersion]
    ) {
      commit('setWorkflowDefinition', {})
      conductor
        .getWorkflowDefinition(
          state.conductorUrl,
          workflowDefinitionName,
          workflowDefinitionVersion
        )
        .then(response => {
          commit('setWorkflowDefinition', response.data)
        })
        .catch(e => commit('handleError', e))
    },
    createWorkflowDefinition({ commit, state }, workflowDefinition) {
      assert(!state.readOnly)
      conductor
        .createWorkflowDefinition(state.conductorUrl, workflowDefinition)
        .then(() => {
          router.push({ name: 'workflowDefinitionList' })
        })
        .catch(e => commit('handleError', e))
    },
    updateWorkflowDefinition({ commit, state }, workflowDefinition) {
      assert(!state.readOnly)
      conductor
        .updateWorkflowDefinition(state.conductorUrl, workflowDefinition)
        .then(() => {
          router.push({
            name: 'workflowDefinition',
            params: {
              workflowDefinitionName: workflowDefinition.name,
              workflowDefinitionVersion: workflowDefinition.version
            }
          })
        })
        .catch(e => commit('handleError', e))
    },
    cancelUpdateWorkflowDefinition(
      { commit },
      [workflowDefinitionName, workflowDefinitionVersion]
    ) {
      commit('setWorkflowDefinition', {})
      router.push({
        name: 'workflowDefinition',
        params: {
          workflowDefinitionName: workflowDefinitionName,
          workflowDefinitionVersion: workflowDefinitionVersion
        }
      })
    },
    removeWorkflowDefinition(
      { commit, state },
      [workflowDefinitionName, workflowDefinitionVersion]
    ) {
      assert(!state.readOnly)
      conductor
        .removeWorkflowDefinition(
          state.conductorUrl,
          workflowDefinitionName,
          workflowDefinitionVersion
        )
        .then(() => {
          commit('setWorkflowDefinition', {})
          router.push({ name: 'workflowDefinitionList' })
        })
        .catch(e => commit('handleError', e))
    },
    // Workflows Management
    getWorkflows({ commit, state }) {
      commit('setWorkflowFilterCount', 0)
      commit('setWorkflows', [])
      conductor
        .getWorkflows(state.conductorUrl, state.workflowFilter)
        .then(response => {
          commit('setWorkflowFilterCount', response.data.totalHits)
          commit('setWorkflows', response.data.results)
        })
        .catch(e => commit('handleError', e))
    },
    getWorkflow({ commit, state }, workflowId) {
      commit('setWorkflow', {})
      conductor
        .getWorkflow(state.conductorUrl, workflowId)
        .then(response => {
          commit('setWorkflow', response.data)
        })
        .catch(e => commit('handleError', e))
    },
    startWorkflow({ commit, state }, workflow) {
      assert(!state.readOnly)
      conductor
        .startWorkflow(state.conductorUrl, workflow)
        .then(response => {
          router.push({
            name: 'workflow',
            params: { workflowId: response.data }
          })
        })
        .catch(e => commit('handleError', e))
    },
    pauseWorkflow({ commit, dispatch, state }) {
      assert(!state.readOnly)
      conductor
        .pauseWorkflow(state.conductorUrl, state.workflow.workflowId)
        .then(() => {
          dispatch('getWorkflow', state.workflow.workflowId)
        })
        .catch(e => commit('handleError', e))
    },
    resumeWorkflow({ commit, dispatch, state }) {
      assert(!state.readOnly)
      conductor
        .resumeWorkflow(state.conductorUrl, state.workflow.workflowId)
        .then(() => {
          dispatch('getWorkflow', state.workflow.workflowId)
        })
        .catch(e => commit('handleError', e))
    },
    rerunWorkflow({ commit, state }, payload) {
      assert(!state.readOnly)
      conductor
        .rerunWorkflow(state.conductorUrl, state.workflow.workflowId, payload)
        .then(response => {
          router.push({
            name: 'workflow',
            params: { workflowId: response.data }
          })
        })
        .catch(e => commit('handleError', e))
    },
    restartWorkflow({ commit, dispatch, state }) {
      assert(!state.readOnly)
      conductor
        .restartWorkflow(state.conductorUrl, state.workflow.workflowId)
        .then(() => {
          dispatch('getWorkflow', state.workflow.workflowId)
        })
        .catch(e => commit('handleError', e))
    },
    retryWorkflow({ commit, dispatch, state }) {
      assert(!state.readOnly)
      conductor
        .retryWorkflow(state.conductorUrl, state.workflow.workflowId)
        .then(() => {
          dispatch('getWorkflow', state.workflow.workflowId)
        })
        .catch(e => commit('handleError', e))
    },
    skipWorkflowTask({ commit, state }, [taskReferenceName, payload]) {
      assert(!state.readOnly)
      conductor
        .skipWorkflowTask(
          state.conductorUrl,
          state.workflow.workflowId,
          taskReferenceName,
          payload
        )
        .then(() => {
          router.push({
            name: 'workflow',
            params: { workflowId: state.workflow.workflowId }
          })
        })
        .catch(e => commit('handleError', e))
    },
    stopWorkflow({ commit, dispatch, state }) {
      assert(!state.readOnly)
      conductor
        .stopWorkflow(state.conductorUrl, state.workflow.workflowId)
        .then(() => {
          dispatch('getWorkflow', state.workflow.workflowId)
        })
        .catch(e => commit('handleError', e))
    },
    archiveWorkflow({ commit, dispatch, state }) {
      assert(!state.readOnly)
      conductor
        .removeWorkflow(state.conductorUrl, state.workflow.workflowId, true)
        .then(() => {
          dispatch('getWorkflow', state.workflow.workflowId)
        })
        .catch(e => commit('handleError', e))
    },
    removeWorkflow({ commit, state }) {
      assert(!state.readOnly)
      conductor
        .removeWorkflow(state.conductorUrl, state.workflow.workflowId, false)
        .then(() => {
          commit('setWorkflow', {})
          router.push({ name: 'workflowList' })
        })
        .catch(e => commit('handleError', e))
    },
    decideWorkflow({ commit, dispatch, state }) {
      assert(!state.readOnly)
      conductor
        .decideWorkflow(state.conductorUrl, state.workflow.workflowId)
        .then(() => {
          dispatch('getWorkflow', state.workflow.workflowId)
        })
        .catch(e => commit('handleError', e))
    },
    // Tasks Management
    getTasks({ commit, state }) {
      commit('setTaskFilterCount', 0)
      commit('setTasks', [])
      conductor
        .getTasks(state.conductorUrl, state.taskFilter)
        .then(response => {
          commit('setTaskFilterCount', response.data.totalHits)
          commit('setTasks', response.data.results)
        })
        .catch(e => commit('handleError', e))
    },
    getTask({ commit, state }, taskId) {
      commit('setTask', {})
      conductor
        .getTask(state.conductorUrl, taskId)
        .then(response => {
          commit('setTask', response.data)
        })
        .catch(e => commit('handleError', e))
    },
    updateTaskResult({ commit, dispatch, state }, taskResult) {
      assert(!state.readOnly)
      conductor
        .updateTaskResult(state.conductorUrl, {
          workflowInstanceId: state.task.workflowInstanceId,
          taskId: state.task.taskId,
          ...taskResult
        })
        .then(() => {
          dispatch('getTask', state.task.taskId)
        })
        .catch(e => commit('handleError', e))
    },
    cancelUpdateTaskResult({ commit }) {
      commit('setTask', {})
      router.push({ name: 'taskList' })
    },
    cancelUpdateTaskResultToWorkflow({ commit, state }) {
      var workflowId = state.task.workflowInstanceId
      commit('setTask', {})
      router.push({ name: 'workflow', params: { workflowId: workflowId } })
    },
    // Queue Management
    getTaskQueues({ commit, state }) {
      commit('setTaskQueues', [])
      Promise.all([
        conductor.getTaskQueueSizeVerbose(state.conductorUrl),
        conductor.getTaskQueuePollData(state.conductorUrl)
      ])
        .then(([responseTaskQueueSize, responseTaskQueuePollData]) => {
          commit('buildTaskQueues', [
            responseTaskQueueSize.data,
            responseTaskQueuePollData.data
          ])
        })
        .catch(e => commit('handleError', e))
    },
    requeuePendingTasks({ commit, dispatch, state }) {
      assert(!state.readOnly)
      conductor
        .requeuePendingTasks(state.conductorUrl)
        .then(() => {
          // Return int of all requeued pending task
          dispatch('getTasks')
          dispatch('getTaskQueues')
        })
        .catch(e => commit('handleError', e))
    },
    requeuePendingTasksByTaskType({ commit, dispatch, state }, taskType) {
      assert(!state.readOnly)
      conductor
        .requeuePendingTasksByTaskType(state.conductorUrl, taskType)
        .then(() => {
          dispatch('getTasks')
          dispatch('getTaskQueues')
        })
        .catch(e => commit('handleError', e))
    },
    dequeueTask({ commit, dispatch, state }, [taskType, taskId]) {
      assert(!state.readOnly)
      conductor
        .dequeueTask(state.conductorUrl, taskType, taskId)
        .then(() => {
          dispatch('getTasks')
          dispatch('getTaskQueues')
        })
        .catch(e => commit('handleError', e))
    },
    ackAllTasks({ commit, dispatch, state }, [count, taskType, domain]) {
      assert(!state.readOnly)
      conductor
        .batchPollTask(
          state.conductorUrl,
          taskType,
          domain ? { domain, count } : { count }
        ) // Conductor can accept empty string domain
        .then(response => {
          Promise.all(
            response.data.map(task => {
              conductor.ackTask(state.conductorUrl, task.taskId)
            })
          )
            .then(() => dispatch('getTaskQueues'))
            .catch(e => commit('handleError', e))
        })
        .catch(e => commit('handleError', e))
    },
    // Event Handler Management
    getEventHandlers({ commit, state }) {
      commit('setEventHandlers', [])
      conductor
        .getEventHandlers(state.conductorUrl)
        .then(response => {
          commit('setEventHandlers', response.data)
        })
        .catch(e => commit('handleError', e))
    },
    getEventHandler({ commit, state }, eventHandlerName) {
      commit('setEventHandler', {})
      conductor
        .getEventHandlers(state.conductorUrl)
        .then(response => {
          commit(
            'setEventHandler',
            response.data.find(a => a.name == eventHandlerName)
          )
        })
        .catch(e => commit('handleError', e))
    },
    createEventHandler({ commit, state }, eventHandler) {
      assert(!state.readOnly)
      conductor
        .createEventHandler(state.conductorUrl, eventHandler)
        .then(() => {
          router.push({ name: 'eventHandlerList' })
        })
        .catch(e => commit('handleError', e))
    },
    updateEventHandler({ commit, state }, eventHandler) {
      assert(!state.readOnly)
      conductor
        .updateEventHandler(state.conductorUrl, eventHandler)
        .then(() => {
          router.push({
            name: 'eventHandler',
            params: {
              eventHandlerName: eventHandler.name
            }
          })
        })
        .catch(e => commit('handleError', e))
    },
    cancelUpdateEventHandler({ commit }, eventHandlerName) {
      commit('setEventHandler', {})
      router.push({
        name: 'eventHandler',
        params: {
          eventHandlerName: eventHandlerName
        }
      })
    },
    removeEventHandler({ commit, state }, eventHandlerName) {
      assert(!state.readOnly)
      conductor
        .removeEventHandler(state.conductorUrl, eventHandlerName)
        .then(() => {
          commit('setEventHandler', {})
          router.push({ name: 'eventHandlerList' })
        })
        .catch(e => commit('handleError', e))
    }
  },
  strict: debug
})
